import { Dialog, DialogFooter, DialogType, Dropdown, IDropdownOption, ITheme, PrimaryButton } from "@fluentui/react";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { queryPlannerItemsAsync } from "src/api/plannerApi";
import { localize } from "src/l10n";
import ThemeContext from "src/style/ThemeContext";
import { SpintrTypes } from "src/typings";
import { Loader } from "src/ui";
import { Editor } from "tinymce";
import PopupHeader from "../../PopupHeader";

interface IProps {
    editor: Editor;
    onClose: () => void;
}

const TinyPlannerItemFunction: React.FC<IProps> = ({ editor, onClose }) => {
    const theme = useContext(ThemeContext) as ITheme;
    const [isLoading, setIsLoading] = useState(true);
    const [plannerItems, setPlannerItems] = useState<IDropdownOption[]>([]);
    const [selectedPlannerItem, setSelectedPlannerItem] = useState<IDropdownOption | undefined>(undefined);

    const fetch = () => {
        setIsLoading(true);
        queryPlannerItemsAsync({
            skip: 0,
            take: 500,
            orderByColumn: "startsAt",
            orderAscending: false,
            status: SpintrTypes.ContentStatus.Published,
        })
            .then((response) => {
                setPlannerItems(
                    response.items.map((item) => {
                        const start = moment(item.startsAt).format("YYYY-MM-DD");
                        const end = moment(item.endsAt).format("YYYY-MM-DD");

                        return {
                            key: item.id,
                            text: `${item.name} (${start} - ${end})`,
                            data: { name: item.name },
                        };
                    }),
                );
                setIsLoading(false);
            })
            .catch(() => {
                setPlannerItems([]);
                setIsLoading(false);
            });
    };

    useEffect(() => {
        fetch();
    }, []);

    const escapeHtml = (str: string): string => {
        const div = document.createElement("div");
        div.appendChild(document.createTextNode(str));
        return div.innerHTML;
    };

    const plannerItemSelected = () => {
        if (!selectedPlannerItem) {
            return;
        }

        const id = Number(selectedPlannerItem.key);

        if (isNaN(id)) {
            return;
        }

        const name = escapeHtml(selectedPlannerItem.data?.name ?? selectedPlannerItem.text);
        const html = `<div><span class="redactorPlannerItem planner-${id}">${name}</span></div> <br />`;

        editor.insertContent(html);
        onClose();
    };

    return (
        <Dialog
            hidden={false}
            containerClassName="dialogWithPopupHeader"
            onDismiss={onClose}
            modalProps={{
                isBlocking: true,
                allowTouchBodyScroll: true,
            }}
            dialogContentProps={{
                type: DialogType.normal,
                title: localize("PLANNER_OBJECT"),
                showCloseButton: true,
                closeButtonAriaLabel: localize("Stang"),
            }}
        >
            <PopupHeader
                text={localize("PLANNER_OBJECT")}
                onClose={onClose}
            />
            {isLoading && <Loader />}
            {!isLoading && (
                <div>
                    <Dropdown
                        selectedKey={selectedPlannerItem?.key ?? null}
                        onChange={(_event: React.FormEvent<HTMLDivElement>, item?: IDropdownOption) => {
                            setSelectedPlannerItem(item);
                        }}
                        options={plannerItems}
                        placeholder={localize("SELECT_PLANNER_OBJECT")}
                    />
                    <DialogFooter>
                        <PrimaryButton
                            theme={theme}
                            disabled={!selectedPlannerItem}
                            onClick={plannerItemSelected}
                            text={localize("Valj")}
                        />
                    </DialogFooter>
                </div>
            )}
        </Dialog>
    );
};

export default TinyPlannerItemFunction;
